'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBalanceScale = function FaBalanceScale(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.5 11.8l-7 12.9h14z m-23.3 0l-7 12.9h14z m14.9-3.5q-0.2 0.8-0.8 1.3t-1.3 0.9v23.5h11.1q0.2 0 0.4 0.2t0.2 0.4v1.1q0 0.3-0.2 0.5t-0.4 0.1h-24.5q-0.3 0-0.4-0.1t-0.2-0.5v-1.1q0-0.3 0.2-0.4t0.4-0.2h11.1v-23.5q-0.8-0.3-1.3-0.9t-0.9-1.3h-8.9q-0.3 0-0.4-0.1t-0.2-0.4v-1.2q0-0.3 0.2-0.4t0.4-0.2h8.9q0.4-1 1.3-1.7t2-0.6 2 0.6 1.3 1.7h9q0.2 0 0.4 0.2t0.2 0.4v1.2q0 0.2-0.2 0.4t-0.4 0.1h-9z m-3.3 0.3q0.6 0 1.1-0.4t0.4-1-0.4-1.1-1.1-0.4-1 0.4-0.4 1.1 0.4 1 1 0.4z m19.8 16.1q0 1.3-0.8 2.4t-2.1 1.6-2.7 0.9-2.5 0.3-2.6-0.3-2.6-0.9-2.1-1.6-0.9-2.4q0-0.2 0.7-1.5t1.6-3.2 2-3.6 1.8-3.3 1.1-1.8q0.3-0.6 1-0.6t1 0.6q0.1 0.1 1 1.8t1.9 3.3 1.9 3.6 1.7 3.2 0.6 1.5z m-23.3 0q0 1.3-0.8 2.4t-2.2 1.6-2.6 0.9-2.5 0.3-2.6-0.3-2.6-0.9-2.2-1.6-0.8-2.4q0-0.2 0.6-1.5t1.7-3.2 2-3.6 1.8-3.3 1-1.8q0.4-0.6 1.1-0.6t1 0.6q0.1 0.1 1 1.8t1.9 3.3 1.9 3.6 1.7 3.2 0.6 1.5z' })
        )
    );
};

exports.default = FaBalanceScale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/balance-scale.js
// module id = 615
// module chunks = 35783957827783